<template>
    <CardPage :section="4" :page="13" :nextFunction="finish" :audio="true">
        <p>
            And, we’ve made it to the end of the first level of the House of LifeSkills. You’ve made your Mother very proud! You’ve earned your first trophy —
            I’ll bet it’s the first of many you’ll earn here!
        </p>
        <ResponsiveImage :src="trophy.image" :alt="trophy.text" flex="xs6" :imgClass="'shine'"></ResponsiveImage>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
    computed: {
        trophy: get('section4/trophy')
    },
    methods: {
        finish() {
            this.$store.set('section4/trophy@earned', true);
        }
    }
};
</script>
